import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Main-Lay" }
const _hoisted_2 = { class: "App-Main-Lay-H" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "App-Main-Lay-Back",
      style: _normalizeStyle({ backgroundImage: `url('${_ctx.img}')` })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { class: "App-Main-Lay-Nav" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "top-nav")
            ]),
            _: 3
          }),
          _createVNode(_component_el_main, {
            style: {"padding":"0"},
            class: _normalizeClass([_ctx.putOnMax ? 'Max' : '', "App-Main-Lay-Main"])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "main")
            ]),
            _: 3
          }, 8, ["class"]),
          _createVNode(_component_el_footer, { class: "App-Main-Lay-Footer" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "footer")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ])
  ]))
}